import { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useGetCalcComissMutation } from 'store/payment/service';
import { setPaymentData } from 'store/payment/slice';

const useCalcComiss = () => {
  const { amount, paymentData, acquiring } = useAppSelector((state) => state.payment);
  const [calcCommission] = useGetCalcComissMutation();
  const [displayMessage, setDisplayMessage] = useState('');
  const dispatch = useAppDispatch();

  useEffect(() => {
    const timeOutId = setTimeout(() => setDisplayMessage(amount), 500);

    return () => clearTimeout(timeOutId);
  }, [amount]);

  useEffect(() => {
    if (displayMessage.length > 0 && acquiring && paymentData) {
      const payload = {
        ID: paymentData.ID,
        amount: Math.abs(+amount) * 100,
        acquiringID: acquiring.ID,
      };

      calcCommission(payload)
        .unwrap()
        .then((res) => {
          dispatch(
            setPaymentData({
              ...paymentData,
              ...res,
            }),
          );
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayMessage]);

  return {};
};

export { useCalcComiss };
